<p-confirmDialog key="modify" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="modifyconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="MainGrid2Col">
	<label>Trigger after X Occurences:</label>
	<div class="InfoGrid">
		<input class="form-control" type="number" min="1" [(ngModel)]="ConsequenceTrigger" />
		<label>(Ex. After the 3rd Time Report to Office, After 5th Time After School Detention)</label>
	</div>

	<label>Description:</label>
	<textarea class="TextArea" rows="5" [(ngModel)]="ConsequenceDesc" placeholder="ex. Report to Office"></textarea>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onProcess()">
		{{ EditMode == false ? "Add" : "Update" }}
	</button>
	<button class="btn btn-warning" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
